export default {
  roundFactory: {
    250: '0x1354908BCF067F002Ff08aA32a3473A8Af7636C3',
  },
  fantomRoundFactory: {
    250: '0x4e3677aB11BA053D205D6A0ffD280E10a8d61F56',
  },
  legacyRoundFactory: {
    250: '0xa6443e08eca804fAb67E830609e70779Dd2497D3',
  },

  workshop: {
    250: '0x1bAc4a19193C9aA9F3E51eC353E05a3B4a1cDB7A',
  },
  workshopV1: {
    250: '0x34a038d9f58Fc9B1830e6CC88cf0646839648a03',
  },
  masterChef: {
    4002: '0x88a9789DCa8A5939986fE743e84f93a3266D474C',
    250: '0x650D853FA19b1A8a3908B85c9b7f9c10F732dFdE',
  },
  midasEmissions: {
    4002: '0x969496503bcF7717352D3e99f53CBDD4a4E146d3',
    250: '0xb95636Af7090cc4DEBB23aCb9811ff668F78C304',
  },
  sousChef: {
    4002: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    250: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  lottery: {
    4002: '0x99c2EcD51d52c036B00130d882Bc65f20Fdecf9f',
    250: '0x3C3f2049cc17C136a604bE23cF7E42745edf3b91',
  },
  lotteryNFT: {
    4002: '0x8175c10383511b3a1C68f9dB222dc14A19CC950e',
    250: '0x5e74094Cd416f55179DBd0E45b1a8ED030e396A1',
  },
  lotteryV2: {
    250: '0xc78819a896815310C1722774aFB1459c6B434FFC',
    4002: '',
  },
  multiCall: {
    4002: '0xCc318e94bd0DeB10BefE519b8B256b0DA7C34409',
    250: '0xccbebfF811475aaB6B731211b46a0407d1550A39',
  },
  pancakeProfile: {
    4002: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    250: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeRabbits: {
    4002: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    250: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    4002: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    250: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    250: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    4002: '',
  },
  pointCenterIfo: {
    4002: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    250: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    4002: '0xFee8A195570a18461146F401d6033f5ab3380849',
    250: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetition: {
    4002: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    250: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  easterNft: {
    4002: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    250: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  cakeVault: {
    250: '0xa80240Eb5d7E05d3F250cF000eEc0891d00b51CC',
    4002: '',
  },
  predictions: {
    4002: '0x516ffd7D1e0Ca40b1879935B2De87cb20Fc1124b',
    250: '0x4f3140C74789F1D809420343ea83BcE52B7bbAA5',
  },
  chainlinkOracle: {
    250: '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE',
    4002: '',
  },
  bunnySpecialCakeVault: {
    250: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    4002: '',
  },
  bunnySpecialPrediction: {
    250: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    4002: '',
  },
}
